module.exports = __webpack_public_path__ + "static/media/tiktok-gif-post-es.c0afdb6c.gif";